import { useHookstate } from "@hookstate/core";
import { readerSettingsStore } from "../../../hookstate/readerSettingsStore";

export function useReaderHintsSettings() {
  const showReaderHints =
    useHookstate(readerSettingsStore.showReaderHints).get() ?? true;

  const toggleShowReaderHints = () => {
    readerSettingsStore.showReaderHints.set(!showReaderHints);
  };

  return { showReaderHints, toggleShowReaderHints };
}
